function InputFormat ($filter) {
    return {
        require: 'ngModel',
        link: function ($scope, elem, attrs, ngModelCtrl) {
            var formatFunc = function () {
                var plainNumber = elem.val().replace(/[^0-9]/g, '').slice(0, 10);
                elem.val($filter(attrs.inputFormat)(plainNumber));
            };

            ngModelCtrl.$parsers.push(function (viewValue) {
                return viewValue.replace(/[^0-9]/g, '').slice(0, 10);
            });

            $scope.$watch(function() {
                return elem.val();
            }, function() {
                formatFunc();
            });
        }
    }
}

angular.module('sentinel').directive('inputFormat', ['$filter', InputFormat]);